module.exports = __webpack_public_path__ + "static/media/caradvise_icon.56dfa378.svg";